import { render, staticRenderFns } from "./contactsEditTags.vue?vue&type=template&id=732c322a&scoped=true"
import script from "./contactsEditTags.vue?vue&type=script&lang=js"
export * from "./contactsEditTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732c322a",
  null
  
)

export default component.exports